module.exports = __webpack_public_path__ + "static/media/Vermelho-Glory.5d672458.png";